import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { AlertModule } from 'ngx-alerts';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { OrdenesComponent } from './views/component/ordenes/ordenes.component'; 
import { ModalModule } from 'ngx-bootstrap/modal';
import { ConfigetiquetaComponent } from './views/component/configetiqueta/configetiqueta.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { HomologacionComponent } from './views/component/homologacion/homologacion.component';
import { CalidadComponent } from './views/component/calidad/calidad.component';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { HojaComponent } from './views/component/hoja/hoja.component';
import { HojaLocalesComponent } from './views/component/hoja-locales/hoja-locales.component';
import { NgChatModule } from 'ng-chat';

import { NgxChatModule } from '@pazznetwork/ngx-chat';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UsuarioComponent } from './views/component/usuario/usuario.component';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { MetaLocalComponent } from './views/component/meta-local/meta-local.component';
import { DashboardReporteComponent } from './views/dashboard_reporte/dashboardReporte.component';
import { ReportVentasxLocalComponent } from './views/component/report-ventasx-local/report-ventasx-local.component';
import { ReportRakingxLocalComponent } from './views/component/report-rakingx-local/report-rakingx-local.component';
import { ReportDevolucionxLocalComponent } from './views/component/report-devolucionx-local/report-devolucionx-local.component';
import { ReportMetaComponent } from './views/component/report-meta/report-meta.component';
import { CatalogoComponent } from './views/component/catalogo/catalogo.component';
import { ManualComponent } from './views/component/manual/manual.component';
import { MatButtonModule } from '@angular/material/button';


import { IKeyboardLayouts, keyboardLayouts, MatKeyboardModule, MAT_KEYBOARD_LAYOUTS } from 'angular-onscreen-material-keyboard';
import { NgxVirtualKeyboardModule } from 'ngx-virtual-keyboard/dist/ngx-virtual-keyboard.module';
import { CrecimientoComponent } from './views/component/crecimiento/crecimiento.component';
import { ReporteCrecimientoComponent } from './views/component/reporte-crecimiento/reporte-crecimiento.component';
import { PublicidadComponent } from './views/component/publicidad/publicidad.component';
import { crecimientoModule } from './views/modelo/usuario/crecimiento';
import { GestionadminComponent } from './views/component/gestionadmin/gestionadmin.component';


const config: SocketIoConfig = { url: 'http://localhost:3000', options: {} };

const customLyouts: IKeyboardLayouts = {
  ...keyboardLayouts,
  'Tolles Layout': {
    name: 'Awesome layout',
    keys: [[['1', '!'], ['2', '@'], ['3', '#']],
    [['Bksp', 'Bksp'], ['0', '0'], ['Enter', 'Enter']]
  ],
    lang: ['de-CH']
  },
  'Numeric Layout': {
    'name': 'numeric',
    'keys': [[['1', '1'], ['2', '2'], ['3', '3']],
    [['4', '4'], ['5', '5'], ['6', '6']],
    [['7', '7'], ['8', '8'], ['9', '9']],
    [['Backspace', 'Backspace'], ['0', '0'], ['Enter', 'Enter']]],
    'lang': ['numeric']
  }
};
const customKeyboardLayouts: IKeyboardLayouts = keyboardLayouts;
customKeyboardLayouts.numpad = {
  'name': 'Numpad', 'keys': [
    [['1', '1'], ['2', '2'], ['3', '3']],
    [['4', '4'], ['5', '5'], ['6', '6']],
    [['7', '7'], ['8', '8'], ['9', '9']],
    [['Bksp', 'Bksp'], ['0', '0'], ['Enter', 'Enter']]
  ]
};
@NgModule({
  imports: [
    BrowserModule,
    NgSelectModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    //SocketIoModule,
  SocketIoModule.forRoot(config),
    AppAsideModule,
    ShowHidePasswordModule,
    NgxPermissionsModule.forRoot(),
    AppBreadcrumbModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    AppFooterModule,
 
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    NgHttpLoaderModule.forRoot(), 
    ModalModule.forRoot(),  
    HttpClientModule,
    FormsModule,
    MDBBootstrapModule.forRoot(),
    AlertModule.forRoot({maxMessages: 5, timeout: 5000}),
    MatButtonModule,
    MatKeyboardModule,
   

  ],
  
    schemas: [ NO_ERRORS_SCHEMA ],
  
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    OrdenesComponent,
    ConfigetiquetaComponent,
    HomologacionComponent,
    CalidadComponent,
 
    DashboardReporteComponent,
   
HojaComponent,
HojaLocalesComponent,
UsuarioComponent,
MetaLocalComponent,
ReportVentasxLocalComponent,
ReportRakingxLocalComponent,
ReportDevolucionxLocalComponent,
ReportMetaComponent,
CatalogoComponent,
ManualComponent,
CrecimientoComponent,
GestionadminComponent,
ReporteCrecimientoComponent,
PublicidadComponent,
  ],
  providers: [
    { provide: MAT_KEYBOARD_LAYOUTS, useValue: customLyouts},
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
   
  },  [DatePipe]],
  
  bootstrap: [ AppComponent ]
})
export class AppModule { }
